import React, { useCallback, useEffect } from 'react';
import { setGroupbyAction } from '../../../redux/slices/oldBuilder';
import { GroupbyKey, QueryType } from '../../../utils/apollo/graphqlSchema';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import {
  funnelGroupByTooltipOption,
  groupbyTooltips,
  pathGroupByTooltipOption,
  retentionGroupByTooltipOption,
} from '../../KubitTooltip/globalTooltips';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../redux/selectors/builder';
import { assertCondition } from '../../../utils/types';
import BuilderEnumSelect from '../BuilderFields/BuilderEnumSelect';

interface IProps {
  queryType: QueryType.Funnel | QueryType.Path | QueryType.Retention;
}

export default ({ queryType }: IProps) => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector(builderDefaultOptionsSelector);
  const selectedOptions = useAppSelector(builderSelectedOptionsSelector);

  assertCondition(
    defaultOptions?.type === queryType && selectedOptions?.type === queryType,
  );

  const groupbyOptions = defaultOptions.groupbys;
  const groupbyKey = selectedOptions.groupby;

  const menuOptions = groupbyOptions.map((gbo) => ({
    ...gbo,
    tooltip: groupbyTooltips[gbo.key],
  }));

  const handleGroupbyChange = useCallback(
    (value: GroupbyKey) => {
      dispatch(setGroupbyAction({ queryType, groupbyKey: value }));
    },
    [dispatch, queryType],
  );

  useEffect(() => {
    if (!groupbyKey && groupbyOptions) {
      handleGroupbyChange(groupbyOptions[0].key);
    }
  }, [groupbyKey, groupbyOptions, handleGroupbyChange]);

  const getTooltipByQueryType = () => {
    // currently only have path & funnel groupby documentation
    // default to funnel for other query types for now
    if (queryType === QueryType.Path) {
      return pathGroupByTooltipOption;
    } else if (queryType === QueryType.Retention) {
      return retentionGroupByTooltipOption;
    } else {
      return funnelGroupByTooltipOption;
    }
  };

  return (
    <BuilderEnumSelect
      label={'Group By'}
      enumOptions={menuOptions}
      selectedOption={groupbyKey as GroupbyKey}
      onChange={handleGroupbyChange}
      tooltipOption={getTooltipByQueryType()}
    />
  );
};
